import { useTranslation } from "react-i18next"

import { getFootnoteId } from "~/utils/articles/getFootnoteId"

import { useFootnotesContext } from "./context"
import { FootnoteContent } from "./FootnoteContent"

const Footnotes: React.FC = () => {
  const { t } = useTranslation("articlePage")
  const footnotes = useFootnotesContext()

  if (!footnotes.length) return null

  return (
    <footer className="m-auto max-w-screen-lg bg-gray-100 p-4 dark:bg-primary-800 md:p-8">
      <h2 className="mb-4 text-xl md:mb-6">{t("footnotes.title")}</h2>
      <ol className="list-inside list-decimal text-sm md:list-outside">
        {footnotes.map((note) => (
          <li
            key={note.number}
            id={getFootnoteId(note.number)}
            className="mb-1 space-x-1"
          >
            <FootnoteContent
              linkClass="text-primary-700 dark:text-white font-medium"
              number={note.number}
            />
          </li>
        ))}
      </ol>
    </footer>
  )
}

export default Footnotes
